// constants/showTypes.js

export const SHOW_ROUTE = 0;
export const SHOW_ROUTE_MODAL = 1;
export const SHOW = 2;
export const SHOW_MODAL = 3;
export const SHOW_DETALL = 4;
export const SHOW_DETALL_FULL = 5;

export const typesShow = [
  { value: SHOW_ROUTE, label: "ROUTE" },
  { value: SHOW_ROUTE_MODAL, label: "ROUTE MODAL" },
  { value: SHOW, label: "INCRUSTADO" },
  { value: SHOW_MODAL, label: "MODAL" },
  {  value: SHOW_DETALL, label: "FORMULARIO DETALLE"},
  {  value: SHOW_DETALL_FULL, label: "FORMULARIO DETALLE FULL"}
];



export const typesForm = [
  { value: 0, label: "EJECUTA FUNCION" },
  { value: 1, label: "LISTADO TABLA" },
  { value: 2, label: "LISTADO CARD" },
  { value: 3, label: "LISTADO CARRUSEL" },

  { value: 4, label: "FORMULARIO PROGRAMADO" },
  { value: 5, label: "FORMULARIO STANDARD" },
  { value: 6, label: "PRESENTACION 3" },
  { value: 7, label: "PRESENTACION 4" },
  { value: 8, label: "OTROS 1" },
  { value: 9, label: "OTROS 2" },
  { value: 10, label: "OTROS 3" },
  
];

export const typesPresent = [
  { value: 0, label: "DEFAULT" },
  { value: 1, label: "TABLA" },
  { value: 2, label: "CARD" },
  { value: 3, label: "CARRUSEL" },
  { value: 4, label: "LISTA SIMPLE" },
  { value: 5, label: "LISTA CON CHECK" },

  
];


export const MSG_ERROR = "0";
export const MSG_EXCLAMACION = "1";
export const MSG_ADVERTENCIA = "2";
export const MSG_PREGUNTA = "3";


